<div class="redemptions-container">
    <!-- Header Section -->
    <div class="redemptions-header">
        <div class="header-content">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
            </div>
            <div class="header-text">
                <h1 class="page-title">Pending Redemptions</h1>
                <p class="page-subtitle">Track customers with active vouchers and manage outreach/follow-up communication</p>
            </div>
        </div>

        <div class="header-actions">
            <button class="btn-refresh" (click)="loadCustomers()" [disabled]="isLoading">
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
                Refresh
            </button>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons" *ngIf="!isLoading && !errorMessage">
        <button class="btn-filter" (click)="toggleFilters()" [class.active]="showFilters">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            <span class="btn-text">Filters</span>
            <span class="filter-badge" *ngIf="hasActiveFilters()">●</span>
        </button>
    </div>

    <!-- Filter Panel -->
    <div class="filter-panel" *ngIf="showFilters" [@slideDown]>
        <div class="filter-header">
            <h3>Filter Customers</h3>
            <button class="btn-close-filters" (click)="toggleFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="filter-grid">
            <!-- Customer Name -->
            <div class="filter-group">
                <label for="customerName">Customer Name</label>
                <input type="text" id="customerName" [(ngModel)]="filters.customerName"
                    placeholder="Search by customer name" class="filter-input">
            </div>

            <!-- Phone Number -->
            <div class="filter-group">
                <label for="customerPhoneNumber">Phone Number</label>
                <input type="text" id="customerPhoneNumber" [(ngModel)]="filters.customerPhoneNumber"
                    placeholder="Search by phone number" class="filter-input">
            </div>

            <!-- Zones Multi-Select Checklist Dropdown -->
            <div class="filter-group zone-dropdown-container">
                <label>Zones</label>
                <div class="zone-dropdown-trigger" (click)="toggleZoneDropdown($event)">
                    <span>{{ getSelectedZonesLabel() }}</span>
                    <i class="fas fa-chevron-down ml-auto text-gray-400"></i>
                </div>
                
                <div class="zone-dropdown-menu" *ngIf="showZoneDropdown" [@slideDown]>
                    <div class="zone-dropdown-item" *ngFor="let zone of zones">
                        <label class="flex items-center cursor-pointer py-1 px-2 hover:bg-gray-50 rounded select-none">
                            <input type="checkbox" [(ngModel)]="zone.selected" class="mr-2 text-green-600 focus:ring-green-500 rounded border-gray-300">
                            <span>{{ zone.name }}</span>
                        </label>
                    </div>
                    <div class="no-zones-msg" *ngIf="zones.length === 0">
                        No zones available
                    </div>
                </div>
            </div>

            <!-- Follow-up Status -->
            <div class="filter-group">
                <label for="status">Outreach Status</label>
                <select id="status" [(ngModel)]="filters.status" class="filter-select">
                    <option [ngValue]="undefined">All Statuses</option>
                    <option *ngFor="let opt of statusOptions" [value]="opt">{{ opt }}</option>
                </select>
            </div>


        </div>

        <div class="filter-actions">
            <button class="btn-clear" (click)="clearFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Clear Filters
            </button>
            <button class="btn-apply" (click)="applyFilters()">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                </svg>
                Apply Filters
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="loading-section" *ngIf="isLoading">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading customers...</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage && !isLoading">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ errorMessage }}</span>
    </div>

    <!-- Customers Grid Table -->
    <div class="customers-section" *ngIf="!isLoading && !errorMessage">
        <!-- Desktop Table View -->
        <div class="table-container desktop-only">
            <table class="redemptions-table" *ngIf="customers.length > 0">
                <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Phone Number</th>
                        <th class="text-center">Available Vouchers</th>
                        <th class="text-right">Total Voucher Value</th>
                        <th class="text-right">Total Min Purchase</th>
                        <th>Zone</th>
                        <th (click)="toggleSort('ExpiryDate')" class="sortable">
                            Upcoming Expiry <i [ngClass]="getSortIcon('ExpiryDate')"></i>
                        </th>
                        <th (click)="toggleSort('LastContacted')" class="sortable">
                            Last Contacted <i [ngClass]="getSortIcon('LastContacted')"></i>
                        </th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let customer of customers">
                        <td class="customer-name font-semibold">{{ customer.customerName }}</td>
                        <td class="phone-number">{{ customer.customerPhoneNumber }}</td>
                        <td class="text-center font-semibold text-green-700">{{ customer.availableVouchersCount }}</td>
                        <td class="text-right font-medium text-gray-900">₹{{ customer.totalVoucherAmount | number:'1.2-2' }}</td>
                        <td class="text-right text-gray-500">₹{{ customer.totalMinPurchaseAmount | number:'1.2-2' }}</td>
                        <td>
                            <span class="zone-badge">{{ customer.zoneName }}</span>
                        </td>
                        <td class="expiry-date" [ngClass]="getExpiryClass(customer.recentExpiryDate)">{{ formatDate(customer.recentExpiryDate) }}</td>
                        <td class="last-contacted">{{ formatDate(customer.lastContacted) }}</td>
                        <td class="text-center">
                            <span class="status-badge" [ngClass]="getStatusClass(customer.followUpStatus)">
                                {{ customer.followUpStatus }}
                            </span>
                        </td>
                        <td class="text-center">
                            <button class="btn-action-followup" (click)="openFollowUpModal(customer)" title="Log outreach & view communication log">
                                <i class="fas fa-comment-dots mr-1"></i> Follow up
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Mobile Card View -->
        <div class="customers-cards mobile-only" *ngIf="customers.length > 0">
            <div class="customer-card" *ngFor="let customer of customers">
                <div class="card-header">
                    <div class="customer-info">
                        <span class="customer-name font-semibold text-lg">{{ customer.customerName }}</span>
                        <span class="phone-number text-sm text-gray-500">{{ customer.customerPhoneNumber }}</span>
                    </div>
                    <span class="status-badge" [ngClass]="getStatusClass(customer.followUpStatus)">
                        {{ customer.followUpStatus }}
                    </span>
                </div>

                <div class="card-body">
                    <div class="card-row">
                        <span class="label">Available Vouchers:</span>
                        <span class="value font-semibold text-green-700">{{ customer.availableVouchersCount }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Total Voucher Value:</span>
                        <span class="value font-semibold text-gray-900">₹{{ customer.totalVoucherAmount | number:'1.2-2' }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Total Min Purchase:</span>
                        <span class="value text-gray-500">₹{{ customer.totalMinPurchaseAmount | number:'1.2-2' }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Upcoming Expiry:</span>
                        <span class="value" [ngClass]="getExpiryClass(customer.recentExpiryDate)">{{ formatDate(customer.recentExpiryDate) }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">Zone:</span>
                        <span class="value"><span class="zone-badge">{{ customer.zoneName }}</span></span>
                    </div>
                    <div class="card-row">
                        <span class="label">Last Contacted:</span>
                        <span class="value">{{ formatDate(customer.lastContacted) }}</span>
                    </div>
                    <div class="card-row-remark">
                        <span class="label">Last Remark:</span>
                        <span class="value italic">{{ customer.lastRemark }}</span>
                    </div>
                </div>

                <div class="card-footer">
                    <button class="btn-action-followup w-full text-center" (click)="openFollowUpModal(customer)">
                        <i class="fas fa-comment-dots mr-1"></i> Log Outreach & View History
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-container" *ngIf="!isLoading && !errorMessage && customers.length > 0">
        <div class="pagination-info">
            <p>Showing {{ (currentPage - 1) * filters.pageSize! + 1 }} to {{ Math.min(currentPage * filters.pageSize!,
                totalCount) }} of {{ totalCount }} customers</p>
            <div class="page-size-selector">
                <label for="pageSizeSelect">Items per page:</label>
                <select id="pageSizeSelect" [(ngModel)]="filters.pageSize" (ngModelChange)="onPageSizeChange($event)" class="page-size-dropdown">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                </select>
            </div>
        </div>
        <div class="pagination-controls">
            <button class="btn-page" (click)="previousPage()" [disabled]="currentPage === 1">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                <span class="btn-text">Previous</span>
            </button>

            <div class="page-numbers">
                <button *ngFor="let page of getPageNumbers()" class="btn-page-number"
                    [class.active]="page === currentPage" (click)="goToPage(page)">
                    {{ page }}
                </button>
            </div>

            <button class="btn-page" (click)="nextPage()" [disabled]="currentPage === totalPages">
                <span class="btn-text">Next</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="customers.length === 0 && !isLoading">
        <div class="empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
        </div>
        <h3>No Customers Found</h3>
        <p>{{ hasActiveFilters() ? 'Try adjusting your filters' : 'All customers have redeemed their vouchers' }}</p>
        <button class="btn-clear-filters" *ngIf="hasActiveFilters()" (click)="clearFilters()">
            Clear Filters
        </button>
    </div>

    <!-- Follow-up Timeline & interaction Modal Overlay -->
    <div class="modal-overlay" *ngIf="showFollowUpModal" [@fadeInOut]>
        <div class="modal-card">
            <!-- Modal Header -->
            <div class="modal-header-section">
                <div class="modal-header-info">
                    <h2>Follow-up Interaction Log</h2>
                    <p class="subtitle">{{ selectedCustomer?.customerName }} ({{ selectedCustomer?.customerPhoneNumber }})</p>
                </div>
                <button class="btn-close-modal" (click)="closeFollowUpModal()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Modal Content (Grid layout for Form and History Timeline) -->
            <div class="modal-body">
                <div class="modal-grid">
                    <!-- Left Section: Log New Action -->
                    <div class="modal-form-section">
                        <h3>Record Outreach Interaction</h3>
                        
                        <div class="form-group-item">
                            <label for="newStatus">Outreach Status</label>
                            <select id="newStatus" [(ngModel)]="newStatus" class="form-input">
                                <option *ngFor="let opt of statusOptions" [value]="opt">{{ opt }}</option>
                            </select>
                        </div>

                        <div class="form-group-item">
                            <label for="newRemarks">Interaction Remarks / Notes</label>
                            <textarea id="newRemarks" [(ngModel)]="newRemarks" 
                                placeholder="Describe the outcome of the phone call or outreach attempt..." 
                                class="form-textarea" rows="4"></textarea>
                        </div>

                        <div class="error-msg-small" *ngIf="saveError">
                            {{ saveError }}
                        </div>

                        <div class="form-actions-modal">
                            <button class="btn btn-secondary btn-sm" (click)="closeFollowUpModal()" [disabled]="isSavingFollowUp">
                                Cancel
                            </button>
                            <button class="btn btn-primary btn-sm" (click)="submitFollowUp()" [disabled]="isSavingFollowUp">
                                <i class="fas fa-spinner fa-spin mr-1" *ngIf="isSavingFollowUp"></i>
                                Save Outreach Log
                            </button>
                        </div>
                    </div>

                    <!-- Right Section: Full History Timeline -->
                    <div class="modal-history-section">
                        <h3>Communication History Log</h3>
                        
                        <div class="timeline" *ngIf="selectedCustomer?.followUpHistory && selectedCustomer!.followUpHistory!.length > 0">
                            <div class="timeline-item" *ngFor="let history of selectedCustomer?.followUpHistory">
                                <div class="timeline-dot" [ngClass]="getStatusClass(history.status)"></div>
                                <div class="timeline-content">
                                    <div class="timeline-header-info">
                                        <span class="history-status-badge" [ngClass]="getStatusClass(history.status)">
                                            {{ history.status }}
                                        </span>
                                        <span class="history-date text-xs text-gray-400">
                                            {{ formatDateTime(history.updatedAt) }}
                                        </span>
                                    </div>
                                    <p class="history-remark text-sm text-gray-700">{{ history.remarks }}</p>
                                    <p class="history-user text-xs text-gray-400 mt-1">
                                        <i class="fas fa-user-circle mr-1"></i> Recorded by: {{ history.updatedByName }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="no-history-state" *ngIf="!selectedCustomer?.followUpHistory || selectedCustomer!.followUpHistory!.length === 0">
                            <div class="no-history-icon">
                                <i class="far fa-comments text-3xl text-gray-300"></i>
                            </div>
                            <p>No communication has been initiated yet with this customer.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
